import { graphql } from "gatsby"
import ProjectComponent from "../components/project"

export default ProjectComponent

export const query = graphql`
  query($slug: String!, $formatString: String!) {
    project(slug: { eq: $slug }) {
      slug
      title
      date(formatString: $formatString)
      description
      body
      excerpt
      banner {
        childImageSharp {
          resize(width: 1200, quality: 90) {
            src
          }
        }
      }
    }
  }
`
